var map = {
	"./cc-america-express.svg": [
		"27b1",
		"icon-cc-america-express-svg"
	],
	"./cc-diners-club.svg": [
		"757a",
		"icon-cc-diners-club-svg"
	],
	"./cc-mastercard.svg": [
		"b91a",
		"icon-cc-mastercard-svg"
	],
	"./cc-union-pay.svg": [
		"9770",
		"icon-cc-union-pay-svg"
	],
	"./cc-visa.svg": [
		"0042",
		"icon-cc-visa-svg"
	],
	"./chatfood-icon.svg": [
		"3748",
		"icon-chatfood-icon-svg"
	],
	"./chatfood-logo-new.svg": [
		"66e8",
		"icon-chatfood-logo-new-svg"
	],
	"./check-complete.svg": [
		"95b8",
		"icon-check-complete-svg"
	],
	"./check-current.svg": [
		"a79f",
		"icon-check-current-svg"
	],
	"./check-incomplete.svg": [
		"521f",
		"icon-check-incomplete-svg"
	],
	"./close-btn-dark.svg": [
		"a740",
		"icon-close-btn-dark-svg"
	],
	"./close-btn.svg": [
		"ddab",
		"icon-close-btn-svg"
	],
	"./congrats.svg": [
		"ded0",
		"icon-congrats-svg"
	],
	"./deliverect.svg": [
		"3d0f",
		"icon-deliverect-svg"
	],
	"./delivery-areas.svg": [
		"91e3",
		"icon-delivery-areas-svg"
	],
	"./discount-gray.svg": [
		"2bfd",
		"icon-discount-gray-svg"
	],
	"./facebook-logo.svg": [
		"14f6",
		"icon-facebook-logo-svg"
	],
	"./facebook-v2.svg": [
		"feba",
		"icon-facebook-v2-svg"
	],
	"./facebook.svg": [
		"c9b0",
		"icon-facebook-svg"
	],
	"./foodics.svg": [
		"f14a",
		"icon-foodics-svg"
	],
	"./google-v2.svg": [
		"eb2b",
		"icon-google-v2-svg"
	],
	"./google.svg": [
		"982f",
		"icon-google-svg"
	],
	"./info.svg": [
		"b43a",
		"icon-info-svg"
	],
	"./instagram-v2.svg": [
		"57ce",
		"icon-instagram-v2-svg"
	],
	"./instagram.svg": [
		"9461",
		"icon-instagram-svg"
	],
	"./lamp.svg": [
		"2035",
		"icon-lamp-svg"
	],
	"./lock.svg": [
		"5257",
		"icon-lock-svg"
	],
	"./messenger.svg": [
		"9a7a",
		"icon-messenger-svg"
	],
	"./stripe.svg": [
		"5461",
		"icon-stripe-svg"
	],
	"./whatsapp-v2.svg": [
		"1d58",
		"icon-whatsapp-v2-svg"
	],
	"./whatsapp.svg": [
		"1633",
		"icon-whatsapp-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4c27";
module.exports = webpackAsyncContext;